import { useState } from "react";
import useRead from "../useRead";

const useGetProductReviews = (productId) => {
  const initialData = {
    pageNo: 0,
    limit: 10,
    searchQuery: "",
    id: productId, // Ensure productId is properly set in the initial params
  };
  
  const { data, paramsObject, setGetListParams } = useRead({
    initialData,
    url: "product/review/list",
    method: "GET",
  });
  
  const handlePageClick = (val) => {
    let pageNo = {
      ...paramsObject,
      pageNo: val.selected,
      id: productId, // Ensure productId is maintained when changing page
    };
    setGetListParams(pageNo);
  };
  
  const handleSearchVal = (e) => {
    let value = e.target.value;
    let copyParams = {
      ...paramsObject,
      searchQuery: value,
      pageNo: 0,
      id: productId, // Ensure productId is maintained when searching
    };
    setGetListParams(copyParams);
  };

  const handleSetLimit = (e) => {
    let value = e.target.value;
    let copyParams = {
      ...paramsObject,
      limit: value,
      id: productId, // Ensure productId is maintained when changing limit
    };
    setGetListParams(copyParams);
  };
  
  return {
    data,
    handlePageClick,
    handleSearchVal,
    handleSetLimit,
    paramsObject,
  };
};

export default useGetProductReviews;
